(function(){
  const GROUP   = 'ecigs';   // même valeur que data-limit-group
  const MIN_QTY = 10;

  // Boutons Checkout (cart + mini-cart)
  const CHECKOUT_BTNS = [
    '.cart-total-wrap .proceed-to-checkout a[href="/checkout"]',
    '.mini-cart .cart-btns a[href="/checkout"]'
  ];

  // Styles pour l’état verrouillé
  (function injectStyle(){
    const css = `
      .ecigs-warning{display:none;margin:12px 0;padding:12px;border:1px solid #f5c2c7;background:red;color:#fff;border-radius:6px;font-size:18px;font-weight:bold;}
      .ecigs-disabled{background:gray !important;color:#fff !important;pointer-events:none !important;opacity:0.85}
    `;
    const s = document.createElement('style'); s.textContent = css; document.head.appendChild(s);
  })();

  function ensureBanner(scope){
    if (!scope) return null;
    let el = scope.querySelector('.ecigs-warning');
    if (!el){
      el = document.createElement('div');
      el.className = 'ecigs-warning';
      scope.prepend(el);
    }
    return el;
  }

  function bannerText(total){
    return `⚠️ Minimum ${MIN_QTY} e-cigs jetables pour passer commande. Actuel : ${total}/${MIN_QTY}.`;
  }

  function setCheckoutEnabled(enabled){
    CHECKOUT_BTNS.forEach(sel=>{
      document.querySelectorAll(sel).forEach(btn=>{
        if (!enabled){
          btn.classList.add('ecigs-disabled');
          btn.setAttribute('aria-disabled','true');
        }else{
          btn.classList.remove('ecigs-disabled');
          btn.setAttribute('aria-disabled','false');
        }
        if (!btn.__ecigsClickBound){
          btn.addEventListener('click', e=>{
            if (btn.getAttribute('aria-disabled') === 'true') e.preventDefault();
          });
          btn.__ecigsClickBound = true;
        }
      });
    });

    // Bloque la soumission du <form action="/cart"> si verrouillé
    document.querySelectorAll('form[action="/cart"]').forEach(form=>{
      form.dataset.ecigsBlock = enabled ? '0' : '1';
      if (!form.__ecigsGuard){
        form.addEventListener('submit', e=>{
          if (form.dataset.ecigsBlock === '1') e.preventDefault();
        });
        form.__ecigsGuard = true;
      }
    });
  }

  function computeGroupTotal(cart){
    let total = 0;
    (cart.items || []).forEach(it=>{
      if (it.properties && it.properties._limit_group === GROUP) total += it.quantity;
    });
    return total;
  }

function refreshUI(){
  return fetch('/cart.js', { headers:{'Accept':'application/json'} })
    .then(r=>r.json())
    .then(cart=>{
      const total    = computeGroupTotal(cart);   // nb d'unités marquées _limit_group=ecigs
      const hasGroup = total > 0;                 // au moins une e-cig jetable dans le panier
      const ok       = !hasGroup || total >= MIN_QTY; // si 0 => OK (pas de règle), sinon >=10 => OK

      // Page panier
      const cartRoot   = document.querySelector('.cart-total-wrap') || document.querySelector('form[action="/cart"]');
      const cartBanner = ensureBanner(cartRoot);
      if (cartBanner){
        if (!hasGroup) {
          cartBanner.style.display = 'none';
        } else {
          cartBanner.style.display = ok ? 'none' : 'block';
          if (!ok) cartBanner.textContent = bannerText(total);
        }
      }

      // PDP
      const pdpRoot   = document.querySelector('.product-details-page .product-main') || document.querySelector('.product-details-page');
      const pdpBanner = ensureBanner(pdpRoot);
      if (pdpBanner){
        if (!hasGroup) {
          pdpBanner.style.display = 'none';
        } else {
          pdpBanner.style.display = ok ? 'none' : 'block';
          if (!ok) pdpBanner.textContent = bannerText(total);
        }
      }

      // Collection
      const collRoot   = document.querySelector('.collection-container') || document.querySelector('.featured-collection') || document.querySelector('.template-collection .container');
      const collBanner = ensureBanner(collRoot);
      if (collBanner){
        if (!hasGroup) {
          collBanner.style.display = 'none';
        } else {
          collBanner.style.display = ok ? 'none' : 'block';
          if (!ok) collBanner.textContent = bannerText(total);
        }
      }

      // Mini-cart
      const miniRoot   = document.querySelector('.mini-cart');
      const miniBanner = ensureBanner(miniRoot);
      if (miniBanner){
        if (!hasGroup) {
          miniBanner.style.display = 'none';
        } else {
          miniBanner.style.display = ok ? 'none' : 'block';
          if (!ok) miniBanner.textContent = bannerText(total);
        }
      }

      // Boutons checkout :
      // - si 0 e-cigs => activés
      // - si 1..9 => désactivés
      // - si >=10  => activés
      setCheckoutEnabled(ok);
    })
    .catch(()=>{ /* silencieux */ });
}


  // ---- Mises à jour automatiques -------------------------------------------------

  // 1) Après ajout au panier
  document.addEventListener('cart:updated', refreshUI);

  // 2) Si un thème fait des fetch vers /cart/add.js → rafraîchir
  if (!window.__ecigsFetchWrap){
    window.__ecigsFetchWrap = true;
    const _fetch = window.fetch;
    window.fetch = function(input, init){
      const p = _fetch.apply(this, arguments);
      try{
        const url = (typeof input === 'string') ? input : (input && input.url) || '';
        if (/\/cart\/(add|change)\.js(\?|$)/.test(url)) p.then(()=>setTimeout(refreshUI, 80));
      }catch(_){}
      return p;
    };
  }

  // 3) Mettre à jour le panier serveur quand tu modifies les quantités dans la page panier
  function bindCartQtyListeners(){
    // Page panier: input.qt avec parent .product-quantity[data-variant="<line_item_key>"]
    document.querySelectorAll('.cart-page .product-quantity[data-variant] input.qt')
      .forEach(inp=>{
        if (inp.__ecigsBound) return;
        inp.__ecigsBound = true;
        const debounced = debounce(e=>{
          const wrap = inp.closest('.product-quantity');
          const lineKey = wrap?.getAttribute('data-variant');
          const qty = parseInt(inp.value || '0', 10) || 0;
          if (!lineKey) return;
          fetch('/cart/change.js', {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({ id: lineKey, quantity: qty })
          }).then(()=>refreshUI());
        }, 300);
        inp.addEventListener('input', debounced);
        inp.addEventListener('change', debounced);
      });

    // Mini-cart: input[name="quantity"] avec parent .product-quantity[data-variant]
    document.querySelectorAll('.mini-cart .product-quantity[data-variant] input[name="quantity"]')
      .forEach(inp=>{
        if (inp.__ecigsBound) return;
        inp.__ecigsBound = true;
        const debounced = debounce(e=>{
          const wrap = inp.closest('.product-quantity');
          const lineKey = wrap?.getAttribute('data-variant');
          const qty = parseInt(inp.value || '0', 10) || 0;
          if (!lineKey) return;
          fetch('/cart/change.js', {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({ id: lineKey, quantity: qty })
          }).then(()=>refreshUI());
        }, 300);
        inp.addEventListener('input', debounced);
        inp.addEventListener('change', debounced);
      });
  }

  function debounce(fn, ms){
    let t; return function(){ clearTimeout(t); t=setTimeout(()=>fn.apply(this, arguments), ms); };
  }

  // Observer pour lier les écouteurs si la page change dynamiquement
  const mo = new MutationObserver(()=>bindCartQtyListeners());
  mo.observe(document.documentElement, {childList:true, subtree:true});

  // Premier passage
  function init(){
    bindCartQtyListeners();
    refreshUI();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
